/* 用户相关接口 */
import http from '@/utils/http'
import store from '@/store/store'

const api = {
  getToken: '/api/getUserInfoByAuthToken',
  getUserInfo: '/api/getUserInfo',
  checkToken: '/api/checkToken'
}

export async function getUserInfo(authToken) {
  let userinfo = null
  try {
    userinfo = await _getToken(authToken)
    store.commit('SET_TOKEN', userinfo.token)
  } catch (e) {
    console.log(e)
  }
  return userinfo
}

export function updateUserInfo(token) {
  return http.get(api.getUserInfo, { token: token })
}

export function checkToken(token) {
  return http.get(api.checkToken, { token: token })
}

function _getToken(authToken) {
  return http.get(api.getToken, { authToken: authToken })
}
